import TmdbService from "../../services/tmdb";

export const FETCH_DETAILS_REQUESTED = "FETCH_DETAILS_REQUESTED";
export const DETAILS_LOADED = "DETAILS_LOADED";
export const DETAILS_ERROR = "DETAILS_ERROR";

const tmdb = new TmdbService();

export const detailsRequested = () => {
  return {
    type: FETCH_DETAILS_REQUESTED
  };
};

export const detailsLoaded = movie => {
  return {
    type: DETAILS_LOADED,
    payload: movie
  };
};

export const detailsError = () => {
  return {
    type: DETAILS_ERROR
  };
};

export const fetchDetailsMovie = (dispatch, id) => {
  dispatch(detailsRequested());
  tmdb
    .getDetails(id)

    .then(data => dispatch(detailsLoaded(data)))
    .catch(() => dispatch(detailsError()));
};
